export const iconsByCategory = {
  default: [2, 3, 4, 5, 6, 7],
  trucks: [
    2000, 2004, 2005, 2006, 2012, 2015, 2016, 2017, 2018, 2019, 3016, 3017, 3018, 3019, 3024, 3025,
    3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041,
    3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057,
    3058,
  ],
  cars: [
    2001, 2002, 2008, 2009, 2021, 2022, 2026, 3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008,
    3009, 3010, 3011, 4004, 4005, 4014, 4015,
  ],
  passenger: [2023, 2027, 3012, 3013, 3014, 3015, 3020, 3021, 3022, 3023, 4035, 4036, 4037],
  specialEquipment: [
    2003, 2007, 2010, 2011, 2013, 2014, 2024, 2028, 2030, 2031, 2033, 3059, 3060, 3061, 3062, 3063,
    3064, 3065, 3066, 3067, 3068, 3069, 3070, 3071, 3072, 3073, 3074, 3075, 3076, 3077, 3078, 3079,
    3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088, 3089, 3090, 3091, 3092, 3093, 3094, 3095,
    3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104, 3105, 4000, 4001, 4002, 4003, 4006, 4007,
    4008, 4009, 4010, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4027, 4028,
    4031, 4032, 4033, 4038, 4039, 4040, 4051, 4052, 4053, 4054, 4055, 4056, 4057, 4066,
  ],
  water: [
    4011, 4012, 4013, 4029, 4030, 4034, 4041, 4058, 4059, 4060, 4067, 4068, 4069, 4070, 4071, 4072,
  ],
  other: [2025, 2029, 2032, 4042, 4043, 4044, 4045, 4046, 4047, 4048, 4049],
  nonTransport: [2020, 3106, 3107, 3108, 3109, 3110],
  animals: [4050, 4073, 4074, 4061, 4062, 4063, 4064, 4065],
} as const;

export type ObjectIconCategory = keyof typeof iconsByCategory;
export type ObjectIconId = (typeof iconsByCategory)[ObjectIconCategory][number];
